import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wd-components',
  template: `
    <p>
      components works!
    </p>
  `,
  styles: []
})
export class ComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
